import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  validaEmail,
  validaNumeroTelefono,
  validaSoloNumero,
} from "../../util/varios";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableContainer } from "@material-ui/core";
import moment from "moment";
import { Dimmer } from "../spinner";
import { GestionarTributos } from "./modalAgregarTributo";

const ModalConfigUserWeb = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState("");
  const [valcerif, setValcerif] = useState("");
  const [operaciontri, setOperaciontri] = useState(0);
  const [operacionpass, setOperacionpass] = useState(0);
  const [operacioneli, setOperacioneli] = useState(0);
  const [tecla, setTecla] = useState();
  const [select, setSelect] = useState("0");
  const [operacion, setOperacion] = useState();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [activate, setActivate] = useState(false);
  const [password, setPassword] = useState();
  const [activo, setActivo] = useState(true);
  const [activo2, setActivo2] = useState(true);
  const [activo3, setActivo3] = useState(true);
  const [activo1, setActivo1] = useState(true);
  const [vista, setVista] = useState(0);
  const [boton, setBoton] = useState(false);
  const [fallecido, setFallecido] = useState(false);
  const [tiponac, setTiponac] = useState(0);
  const [tributo, setTributo] = useState([]);
  const [tributos, setTributos] = useState();
  const [values, setValues] = useState({
    idusuarioweb: "",
    login: "",
    direccion: "",
    idcomercio: "",
    email2: "",
    estatus: "",
    cedula: "",
    nombre: "",
    direccion: "",
    telefono: "",
    rif: "",
    dirip: "",
    nacionalidad: "",
    passwd: "",
    juridico: 0,
  });
  const [body, setBody] = useState({});
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [rif, setRif] = useState();
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const cmbNacionalidad = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const accuserweb = JSON.parse(localStorage.getItem("accuserweb"));

  moment.locale("es-us");

  var fecha = moment(fechaSistema).subtract(18, "year").calendar();

  const generar = (longitud) => {
    var long = parseInt(longitud);
    var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
    var contraseña = "";
    for (var i = 0; i < long; i++)
      contraseña += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      );
    return contraseña;
  };
  let pass = generar(6).toString();

  const blanquear = () => {
    setPassword("");
    setValcerif("");
    setActivate(false);
    setValues({
      idusuarioweb: "",
      login: "",
      direccion: "",
      idcomercio: 0,
      email2: "",
      estatus: "",
      cedula: "",
      nombre: "",
      direccion: "",
      telefono: "",
      rif: 0,
      dirip: "",
      nacionalidad: "",
      passwd: "",
      juridico: 0,
    });
    setActivo(true);
    setFallecido(false);
    setActivo1(true);
    setBoton(false);
    setActivo2(true);
    setActivo3(true);
    setOperacion(0);
    setOperacioneli(0);
    setOperacionpass(0);
    setOperaciontri(0);
    setRif(0);
  };

  const seleccionarTriburo = (id) => {
    let campos = "*";
    let nomtab = "mistributos";
    let nomid = "idusuarioweb";

    let endpoint = `${op.conexion}/api/consultaweb/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuarioweb > 0) {
            setTributos(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (event.target.name === "cedula") {
      validaSoloNumero(event);
      let tiponaci = txtCedula.current.value;
      setRif(0);
      setTiponac(tiponaci);
    } else if (event.target.name === "telefono") {
      validaSoloNumero(event);
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onButtons = (op, id) => (e) => {
    if (props.operacion === 2) {
      if (op === 1) {
        setActivo(false);
        setActivo1(true);
        setActivo2(false);
        setActivo3(false);
        setBoton(true);
        setOperacion(2);
        setOperacioneli(0);
        setOperaciontri(0);
        setOperacionpass(0);
        setTimeout(() => {
          txtNombreUsuario.current.focus();
        }, 500);
      } else if (op === 2) {
        setActivo1(false);
        setActivo(true);
        setActivo2(false);
        setActivo3(true);
        setOperacion(2);
        setOperacioneli(0);
        setOperaciontri(0);
        setOperacionpass(0);
        setTimeout(() => {
          txtLogin.current.focus();
        }, 500);
      } else if (op === 3) {
        setOperacion(0);
        setOperacioneli(7);
        setOperaciontri(0);
        setOperacionpass(0);
        setActivo1(true);
        setActivo(true);
        setActivo2(true);
        setActivo3(true);
        let msg = "";
        msg = "Esta Seguro de Eliminar este Usuario?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else if (op === 4) {
        setMostrar(true);
        setOperaciontri(4);
      } else if (op === 5) {
        setOperacion(0);
        setOperacionpass(0);
        setOperacioneli(0);
        setOperaciontri(5);
        seleccionarTriburo(id);
        let msg = "";
        msg = "Esta Seguro de Eliminar este Tributo?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else if (op === 6) {
        let pass = generar(6).toString();
        setActivo2(true);
        setActivo1(true);
        setActivo(true);
        setActivo3(true);
        setOperacion(0);
        setOperacionpass(6);
        setOperaciontri(0);
        setOperacioneli(0);
        setPassword(pass);
        let msg = "";
        msg = "Esta Seguro de Cambiar la Contraseña?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else {
        setActivo1(true);
        setActivo(true);
        setActivo2(true);
        setActivo3(true);
      }
    } else {
      setActivo1(false);
      setActivo(false);
    }
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  /*     const handleInputPhone = (event) => {
            event.preventDefault();
    
            if (!validaNumeroTelefono(event.target.value)) {
                if (event.target.id === 'cel') {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Número de Telefono no valido', icono: 'informacion' });
                    txtTlfUsuario.current.value = '';
                    txtTlfUsuario.current.focus();
                }
            }
    
        }; */

  /*     const handleInputChange = (event) => {
            if (event.which === 13) {
                var valido;
                if (event.target.id === 'inputLogin') {
                    valido = validaEmail(event.target.value);
                    if (valido) {
                        txtLogin.current.focus();
                    } else {
                        if (event.target.value !== '') {
                            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El Usuario debe ser Tipo E-mail.', icono: 'informacion' });
                            event.target.value = '';
                            txtLogin.current.focus();
                        } else {
                            txtLogin.current.focus();
                        }
                    }
                } else if (event.target.id === 'inputEmailUsuario') {
                    valido = validaEmail(event.target.value);
                    if (valido) {
                        btnAcepta.current.focus();
                    } else {
                        if (event.target.value !== '') {
                            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Formato de Email invalido.', icono: 'informacion' });
                            event.target.value = '';
                        } else {
                            btnAcepta.current.focus();
                        }
                    }
    
                }
            } else if (typeof (event.which) === 'undefined') {
                if (event.target.id === 'inputLogin') {
                    valido = validaEmail(event.target.value);
                    if (valido) {
                        txtLogin.current.focus();
                    } else {
                        if (event.target.value !== '') {
                            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El Usuario debe ser Tipo E-mail.', icono: 'informacion' });
                            event.target.value = '';
                            txtLogin.current.focus();
                        } else {
                            txtLogin.current.focus();
                        }
                    }
                } else if (event.target.id === 'inputEmailUsuario') {
                    valido = validaEmail(event.target.value);
                    if (valido) {
                        btnAcepta.current.focus();
                    } else {
                        if (event.target.value !== '') {
                            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Formato de Email invalido.', icono: 'informacion' });
                            event.target.value = '';
                            txtEmailUsuario.current.focus();
                        } else {
                            btnAcepta.current.focus();
                        }
                    }
    
                } else {
                    return false;
                }
    
            } else if (event.which === 46) {
                return false;
            } else if (event.which >= 48 && event.which <= 57) {
                return true;
            } else if (event.which === 8 || event.which === 0 || event.which === 44) {
                return true;
            } else return false;
        };
     */
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (cmbNacionalidad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar la Nacionalidad",
        icono: "informacion",
      });
      sigue = false;
      cmbNacionalidad.current.value = "";
      cmbNacionalidad.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca su Número de Cédula",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.value = "";
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Campo Nombre no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombreUsuario.current.value = "";
      txtNombreUsuario.current.focus();
    } else if (txtTlfUsuario.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir por lo menos un Número Telefonico",
        icono: "informacion",
      });
      sigue = false;
      txtTlfUsuario.current.value = "";
      txtTlfUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Campo Dirección no debe ir Vacio, Describa la Dirección",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionUsuario.current.value = "";
      txtDireccionUsuario.current.focus();
    } else if (txtLogin.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir su Usuario",
        icono: "informacion",
      });
      sigue = false;
      txtLogin.current.value = "";
      txtLogin.current.focus();
    } else if (txtEmailUsuario.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Campo E-mail Secundario no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtEmailUsuario.current.value = "";
      txtEmailUsuario.current.focus();
    } else if (!validaEmail(txtLogin.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un correo valido",
        icono: "informacion",
      });
      txtLogin.current.value = "";
      txtLogin.current.focus();
      sigue = false;
    } else if (!validaEmail(txtEmailUsuario.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un correo valido",
        icono: "informacion",
      });
      txtEmailUsuario.current.value = "";
      txtEmailUsuario.current.focus();
      sigue = false;
    } else if (sigue) {
      var usuario = [];

      usuario.push({
        idusuarioweb: parseInt(txtIdUsuario.current.value),
        login: txtLogin.current.value.trim().toLowerCase(),
        email2: txtEmailUsuario.current.value.trim().toLowerCase(),
        estatus: 0,
        cedula: tiponac,
        nombre: txtNombreUsuario.current.value.trim(),
        direccion: txtDireccionUsuario.current.value.trim(),
        telefono: txtTlfUsuario.current.value.trim(),
        rif: rif,
        nacionalidad: cmbNacionalidad.current.value.trim(),
        passwd: password,
        idcomercio: 0,
        juridico: props.juridic === 7 ? 1 : parseInt(props.juridico),
      });
      setBody({
        usuario: usuario,
      });
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = "";

    endpoint = `${op.conexion}/api/usuarioweb/actualizarusuweb/${parseInt(
      operacion
    )}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Usuario Creado Correctamente, Su Clave fue Enviada al Correo Registrado!",
              icono: "exito",
            });
            enviarCorreo();
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const ActualizarTributos = () => {
    let endpoint = `${op.conexion}/api/usuarioweb/actualizartributos/${operaciontri}`;
    let body;
    setActivate(true);

    body = {
      idusuariow: parseInt(tributos.idusuarioweb),
      tributo: tributos.tributo,
      idtributo: parseInt(tributos.idtributo),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idusu !== null) {
            setMensaje({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
            props.onHideRender(parseInt(response.data.idusu));
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const enviarCorreo = () => {
    let endpoint = op.email + "/send-email";

    axios
      .post(endpoint, {
        email: txtLogin.current.value,
        name: txtNombreUsuario.current.value,
        passwd: password,
        message: "",
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacionpass === 6) {
            setMensaje({
              mostrar: true,
              titulo: "Confirmación.",
              texto:
                "Contraseña Cambiada Correctamente! " +
                response.data.respuesta +
                values.login,
              icono: "exito",
            });
          }
        } else if (response.status == 204) {
          setMensaje({
            mostrar: true,
            titulo: "Confirmación.",
            texto: response.respuesta,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const ActualizarPass = () => {
    let endpoint = `${op.conexion}/api/usuarioweb/actualizarusupass/${operacionpass}`;
    let body;
    setActivate(true);

    body = {
      idusuariow: parseInt(txtIdUsuario.current.value),
      passwd: password,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacionpass === 6) {
            enviarCorreo();
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const EliminarUsuarioWeb = () => {
    let endpoint = `${op.conexion}/api/usuarioweb/eliminarusuweb/${operacioneli}`;
    let body;
    setActivate(true);

    body = {
      idusuariow: parseInt(txtIdUsuario.current.value),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro eliminado correctamente",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      procesarRegistro();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      procesarRegistro();
    }

    if (operaciontri === 5) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      ActualizarTributos();
    } else if (operacionpass === 6) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      ActualizarPass();
    } else if (operacioneli === 7) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      EliminarUsuarioWeb();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
    blanquear();
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const handleCancela2 = () => {
    setMostrar(false);
    props.onHideRender(parseInt(txtIdUsuario.current.value));
  };

  useEffect(() => {
    setTributo(props.tributo);
  }, [props.tributo]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.usuario);
          setTiponac(props.usuario.cedula);
          setRif(props.usuario.rif);
          setValcerif(props.usuario.cedula);
        }

        let pass = generar(6).toString();
        if (props.operacion === 1) {
          setPassword(pass);
          setActivo(false);
          setActivo1(false);
          setActivo3(false);
          cmbNacionalidad.current.value = "";
          setSelect("0");
          setActivo2(false);
        } else {
          setPassword(props.usuario.passwd);
          setSelect("1");
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registro de Usuario Web"
              : operacion === 2
              ? "Gestión de Usuario Web"
              : operacion === 3
              ? "Eliminar Usuario"
              : ""}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <GestionarTributos
        show={mostrar}
        operaciontri={operaciontri}
        idusuario={props.idusuario}
        onHideCancelar={handleCancela2}
      />
      <Modal.Body style={{ padding: 0 }}>
        <div className="">
          <ul className="nav nav-tabs mb-2" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active h-35p p-3 fw-bold"
                style={{ backgroundColor: "#25d366" }}
                id="ex-with-icons-tab-1"
                data-mdb-toggle="tab"
                href="#tab-1"
                role="tab"
                aria-controls="tab-1"
                aria-selected="true"
              >
                <i className="fas fa-info-circle fa-fw me-2"></i>Datos Generales
              </a>
            </li>
            {select === "0" ? (
              <div></div>
            ) : select === "1" ? (
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link h-35p p-3 fw-bold"
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  data-mdb-toggle="tab"
                  href="#tab-2"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Tributos
                </a>
              </li>
            ) : (
              ""
            )}
          </ul>
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="container">
                <div className="col-sm-12 row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={values ? values.idusuarioweb : ""}
                      id="inputCodigo"
                    />
                  </div>
                  <div className="col-md-2 py-1 ml-auto">
                    <label className="form-label fw-bold">
                      {props.juridic === 7 || parseInt(props.juridico) === 1
                        ? "JURIDICO"
                        : "NATURAL"}
                    </label>
                  </div>
                </div>

                <fieldset className="row border-azul rounded mx-auto">
                  <legend className="float-none m-0 w-auto">
                    Datos del Usuario
                  </legend>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>
                      {props.juridic === 7 || parseInt(props.juridico) === 1
                        ? "RIF"
                        : "Cédula"}
                    </label>
                    {props.natur === 4 ? (
                      <select
                        ref={cmbNacionalidad}
                        disabled={activo3}
                        className="form-select col-2 px-1"
                        name="nacionalidad"
                        defaultValue={
                          props.usuario && props.usuario.nacionalidad !== null
                            ? props.usuario.nacionalidad.trim()
                            : values && values.nacionalidad
                        }
                        aria-label="Default select example"
                        onChange={onChange}
                      >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>
                    ) : props.juridic === 7 ? (
                      <select
                        ref={cmbNacionalidad}
                        disabled={activo3}
                        className="form-select col-2 px-1"
                        name="nacionalidad"
                        defaultValue={
                          props.usuario && props.usuario.nacionalidad !== null
                            ? props.usuario.nacionalidad.trim()
                            : values && values.nacionalidad
                        }
                        aria-label="Default select example"
                        onChange={onChange}
                      >
                        <option value="">--</option>
                        <option value="J">J</option>
                        <option value="V">V</option>
                        <option value="G">G</option>
                        <option value="P">P</option>
                      </select>
                    ) : parseInt(props.juridico) === 1 ? (
                      <select
                        ref={cmbNacionalidad}
                        disabled={activo3}
                        className="form-select col-2 px-1"
                        name="nacionalidad"
                        defaultValue={
                          props.usuario && props.usuario.nacionalidad !== null
                            ? props.usuario.nacionalidad.trim()
                            : values && values.nacionalidad
                        }
                        aria-label="Default select example"
                        onChange={onChange}
                      >
                        <option value="">--</option>
                        <option value="J">J</option>
                        <option value="V">V</option>
                        <option value="G">G</option>
                        <option value="P">P</option>
                      </select>
                    ) : (
                      <select
                        ref={cmbNacionalidad}
                        disabled={activo3}
                        className="form-select col-2 px-1"
                        name="nacionalidad"
                        defaultValue={
                          props.usuario && props.usuario.nacionalidad !== null
                            ? props.usuario.nacionalidad.trim()
                            : values && values.nacionalidad
                        }
                        aria-label="Default select example"
                        onChange={onChange}
                      >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>
                    )}

                    <input
                      type="text"
                      disabled={activo3}
                      maxLength={8}
                      ref={txtCedula}
                      autoComplete="off"
                      onChangeCapture={onChange}
                      className="form-control bg-light col-sm-4 col-12"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="cedula"
                      defaultValue={valcerif}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-3 ml-auto">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-mobile-alt fa-lg px-1"></i>Telefono:
                    </label>
                    <input
                      type="text"
                      disabled={activo}
                      ref={txtTlfUsuario}
                      maxLength={11}
                      autoComplete="off"
                      name="telefono"
                      className="form-control bg-light"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        values
                          ? values.telefono !== null
                            ? values.telefono.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputNumChange}
                      /*  onBlur={handleInputPhone} */ id="cel"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>
                      {props.juridic === 7 || parseInt(props.juridico) === 1
                        ? "Razón Social"
                        : "Nombres y Apellidos"}
                    </label>
                    <input
                      type="text"
                      disabled={activo}
                      ref={txtNombreUsuario}
                      autoComplete="off"
                      className="form-control bg-light text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        values
                          ? values.nombre !== null
                            ? values.nombre.trim()
                            : ""
                          : ""
                      }
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      <i className="fas fa-lg px-1 fa-map-marker-alt"></i>{" "}
                      Direccion:
                    </label>
                    <textarea
                      disabled={activo}
                      ref={txtDireccionUsuario}
                      autoComplete="off"
                      style={{ height: "50px" }}
                      className="form-control bg-light text-uppercase"
                      defaultValue={
                        values
                          ? values.direccion !== null
                            ? values.direccion.trim()
                            : ""
                          : ""
                      }
                    />
                  </div>
                </fieldset>

                <div className="col-md-12 py-2"></div>

                <fieldset className="row border-azul rounded mx-auto">
                  <legend className="float-none m-0 w-auto">
                    Datos del Registro Web
                  </legend>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-user-circle"></i>Usuario:
                    </label>
                    <input
                      type="text"
                      disabled={activo1}
                      ref={txtLogin}
                      autoComplete="off"
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                      defaultValue={
                        values && values.login
                          ? values.login !== null
                            ? values.login.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={onChange}
                      onBlur={onChange}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-at fa-lg px-1"></i>E-mail Secundario:
                    </label>
                    <input
                      type="text"
                      disabled={activo1}
                      ref={txtEmailUsuario}
                      autoComplete="off"
                      name="email"
                      onChange={onChange}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputEmailUsuario"
                      defaultValue={
                        values && values.email2
                          ? values.email2 !== null
                            ? values.email2.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={onChange}
                      onBlur={onChange}
                    />
                  </div>
                </fieldset>

                <div className="col-md-12 py-2"></div>

                {select === "0" ? (
                  <div></div>
                ) : select === "1" ? (
                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">Opciones</legend>

                    <div className="col-md-3 col-xs-2">
                      <button
                        className="col-md-12 rounded-pill btn-sm btn btn-primary p-0"
                        onClick={onButtons(1)}
                        disabled={operacion === 1 ? true : deshabilitado}
                      >
                        <div className="col-md-12 col-12 row m-0">
                          <div className="col-md-2 col-2">
                            <i className="fas fa-user-edit px-1"></i>
                          </div>
                          <div className="col-md-7 col-8">
                            <i className="fas text-left px-2">Editar Usuario</i>
                          </div>
                        </div>
                      </button>
                    </div>

                    <div className="col-md-3 col-xs-2">
                      <button
                        className="col-md-12 rounded-pill btn-sm btn btn-info p-0"
                        onClick={onButtons(2)}
                        disabled={operacion === 1 ? true : deshabilitado}
                      >
                        <div className="col-md-12 col-12 row m-0">
                          <div className="col-md-2 col-2">
                            <i className="fas fa-envelope px-1"></i>
                          </div>
                          <div className="col-md-7 col-8 px-1">
                            <i className="fas text-left px-2">Cambiar Correo</i>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div className="col-md-3 col-xs-2">
                      <button
                        className="col-md-12 rounded-pill btn-sm btn btn-warning p-0"
                        style={{ pointerEvents: accuserweb.substring(2, 3) }}
                        onClick={onButtons(6)}
                        disabled={operacion === 1 ? true : deshabilitado}
                      >
                        <div className="col-12 row m-0">
                          <div className="col-md-2 col-2 px-0">
                            <i className="fas fa-key px-1"></i>
                          </div>
                          <div className="col-md-7 col-8 px-0">
                            <i className="fas text-left px-0">
                              Cambiar Contraseña
                            </i>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div className="col-md-3 col-xs-2">
                      <button
                        className="col-md-12 rounded-pill btn-sm btn btn-danger p-0"
                        onClick={onButtons(3)}
                        disabled={operacion === 1 ? true : deshabilitado}
                      >
                        <div className="col-md-12 col-12 row m-0">
                          <div className="col-md-2 col-2">
                            <i className="fa fa-trash-alt px-1"></i>
                          </div>
                          <div className=" col-md-8 col-8 px-1">
                            <i className="fas text-left px-2">
                              Eliminar Registro
                            </i>
                          </div>
                        </div>
                      </button>
                    </div>
                  </fieldset>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="tab-2"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-2"
            >
              <div className="row col-md-12 mx-auto px-1 mt-2">
                <fieldset className=" row col-md-12 border-azul rounded mx-auto">
                  <legend className="float-none w-auto">
                    {" "}
                    Tributos Asociados a este Usuario
                  </legend>

                  <div
                    className="row col-md-12 d-flex justify-content-end"
                    style={{ padding: "10px" }}
                  >
                    <div className="col-md-4 col-xs-2 d-flex justify-content-end">
                      <button
                        className="btn btn-sm btn-primary rounded-pill"
                        onClick={onButtons(4, "")}
                      >
                        <i className="fas fa-plus"> incluir</i>
                      </button>
                    </div>
                  </div>
                  <TableContainer className="h-150p max-250p">
                    <table
                      className="table table-striped text-light table-hover"
                      style={{ border: "solid #055182" }}
                    >
                      <thead>
                        <tr className="azulGradiant">
                          <th className="text-center">CÓDIGO</th>
                          <th className="text-center">TRIBUTO</th>
                          <th className="text-center">NOMBRES</th>
                          <th className="text-center">OPCIONES</th>
                        </tr>
                      </thead>

                      <tbody className="border-light">
                        {tributo &&
                          tributo.map((item, index) => (
                            <tr key={index + item.idusuarioweb}>
                              <td
                                className="text-dark"
                                align="center"
                                style={{ fontSize: "12px" }}
                              >
                                {item.idtributo}
                              </td>
                              <td
                                className="text-dark"
                                align="center"
                                style={{ fontSize: "12px" }}
                              >
                                {item.tributo}
                              </td>
                              <td
                                className="text-dark"
                                align="left"
                                style={{ fontSize: "12px" }}
                              >
                                {item.nombre}
                              </td>
                              <td className="text-dark " align="center">
                                <button
                                  onClick={onButtons(
                                    5,
                                    item.idusuarioweb,
                                    item.tributo,
                                    item.idtributo
                                  )}
                                  className="btn btn-sm btn-danger rounded-circle"
                                >
                                  <i className="fa fa-trash-alt"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </TableContainer>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            disabled={activo2 === true ? true : deshabilitado}
            ref={btnAcepta}
            onClick={onChangeValidar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>

          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default ModalConfigUserWeb;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalConfUserWeb.js